// extracted by mini-css-extract-plugin
module.exports = {"startContainer":"start_startContainer__1pEDm","start":"start_start__1kJ2P"};